<template lang="pug">
	
	.splited-text
		p.text {{text}}
		

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import * as PIXI from 'pixi.js'
	import Scrollable from '~abstracts/scrollable'
	import LineThenWord from '~utils/text-spliter.js'
	import Globals from '~utils/Globals.js'


  	@Component({
		name: 'SplitedText',
		components: {  },
        props: ["text"]
	})

	class SplitedText extends Scrollable {

		mounted () {
			super.mounted()

            this.splited = new LineThenWord(".text",this.$el, this.text)

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
		
		}

		initTimeline () {
			super.initTimeline()
		}

		raf (y) {
			super.raf(y)	
		}

		_intervals () {
            const l = this.splited.splited.length			
			this.tlAppear = new TimelineMax({paused:true})

			for(let i = 0; i < l; i++) {		
				let $words = this.splited.splited[i]
				this.tlAppear.staggerTo($words,1,{y:0,opacity:1,delay:.1*i, ease:Power3.easeOut},.01,0)
			}
		}
		
		animateIn () {
			const p = this.tlAppear.progress()
			// this.tlAppear.updateTo({ease: Power3.easeOut})
			this.tlAppear.play(p)
		} 

		animateOut () {
			const p = this.tlAppear.progress()
			// this.tlAppear.updateTo({ease: Power3.easeIn})
			this.tlAppear.reverse(p)
		}

		_resize () {
			super._resize()

			this.splited.resize()
			this._intervals()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default SplitedText

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.splited-text

		p.line
			color #fff
			font-family $FONT_THIRDLY
			font-weight 700
			font-size em(20px)
			line-height em(50px,20px)

			span
				opacity 0
				display inline-block
				transform translate3d(0,50px,0)

				// +break(xs)
				// 	opacity 1
				// 	transform none

	
</style>


// WEBPACK FOOTER //
// splited-text.vue?36732de3